<template>
  <span>
    <collapsed-card collapse-key="active" title-text="Current Studies" class="mt-2">
      <surveys-data-provider type="active" :society-id="society.id" :is-gm-admin-type="isGmAdminType">
        <template slot-scope="{ items, isBusy }">
          <surveys-table
            :is-busy="isBusy"
            :surveys="items"
            :is-gm-admin-type="isGmAdminType"
            :with-primary="true"
            empty-message="There are no active studies at this time."
          >
          </surveys-table>
        </template>
      </surveys-data-provider>
    </collapsed-card>
    <collapsed-card
      collapse-key="mss-upcoming"
      title-text="Upcoming Studies"
      class="mt-2"
    >
      <surveys-data-provider type="upcoming" :society-id="society.id" :is-gm-admin-type="isGmAdminType">
        <template slot-scope="{ items, isBusy }">
          <surveys-table
            :is-busy="isBusy"
            :surveys="items"
            :is-gm-admin-type="isGmAdminType"
            empty-message="There are no upcoming studies."
          >
          </surveys-table>
        </template>
      </surveys-data-provider>
    </collapsed-card>
    <collapsed-card collapse-key="mss-past" title-text="Past Studies" class="mt-2">
        <surveys-data-provider type="completed" :society-id="society.id" :is-gm-admin-type="isGmAdminType">
          <template slot-scope="{ items, isBusy }">
            <completed-surveys
              :is-busy="isBusy"
              :surveys="items"
              :is-gm-admin-type="isGmAdminType"
              empty-message="There are no closed studies."
            />
          </template>
        </surveys-data-provider>
    </collapsed-card>
  </span>
</template>

<script>
import SurveysTable from './SurveysTable';
import CompletedSurveys from './CompletedSurveys';
import SurveysDataProvider from '@/components/mss_admin/dashboard/SurveysDataProvider';
import CollapsedCard from '@/components/ui-elements/CollapsedCard';

export default {
  name: 'QuestionnairesAndSurveys',
  components: {
    SurveysTable,
    CompletedSurveys,
    SurveysDataProvider,
    CollapsedCard,
  },
  props: {
    society: {
      required: true,
      type: Object,
    },
    isGmAdminType: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
